import { useQuery } from "@tanstack/react-query";
import { getSiteById } from "../actions/getSiteById.actions";

export const SITE_BY_ID_QK = (siteId: string) => ["page-builder", "sites", "by-id", siteId] as const;

type Options = {
    enabled?: boolean;
};

export function useSiteByIdQuery(siteId: string | undefined, options: Options = {}) {
    const { enabled = true } = options;

    return useQuery({
        queryKey: SITE_BY_ID_QK(siteId ?? ""),
        queryFn: () => getSiteById(siteId as string),
        enabled: enabled && !!siteId,
        staleTime: 30_000,
    });
}
